var map = {
	"./CalsaOT.png": 4463,
	"./Marketaudit.png": 4703,
	"./icons8-github-32.png": 5628,
	"./icons8-instagram-32.png": 3539,
	"./icons8-linkedin-32.png": 8493,
	"./icons8-modo-de-color-48.png": 5861,
	"./profilePng.png": 3776
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7695;